export const messages = {
  500: {
    title: 'HA OCURRIDO UN ERROR',
    text: 'Por favor vuelva a intentar de nuevo, si el problema continua comuniquese con nosotros.'
  },
  404: {
    title: 'ELEMENTO NO ENCONTRADO',
    text: 'La consulta realizada no ha devuelto resultados, por favor revise el o los campos ingresados.'
  },
  401: {
    title: 'NO TIENE PERMISOS',
    text: 'La información solicitada no esta disponible debido a que no cuenta con los permisos suficientes para acceder.'
  },
  403: {
    title: 'DEBE INICIAR SESIÓN',
    text: 'Para poder acceder a este contenido debe de iniciar sesión, si no se ha registrado puede hacerlo.'
  },
  409: {
    title: 'ELEMENTO ASOCIADO A ESTE',
    text: 'Este elemento esta asociado a otro u otros elementos, por favor revisa si es correcto y vuelve a intentar'
  },
  413: {
    title: 'TAMAÑO DEMASIADO GRANDE',
    text: 'El tamaño de este elemento excede el máximo definido por el servidor, verifique las configuraciones de este.'
  },
  415: {
    title: 'FORMATO NO VÁLIDO',
    text: 'El formato de este elemento no es aceptado, por favor, elija un formato válido'
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/locale/messages.js